import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Joi from "@hapi/joi";
import { CustomerAccountReportSchemaObject } from "../customerAccountReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import { LoadingMaterialTable } from "../../../../Common/table";

const screenCode = "CUSTOMERACCOUNTREPORT";

export function CustomerAccountReport(props) {

    const componentRef = useRef();
    const [reportData, setReportData] = useState([]);
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionVariance, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        statusID: "-1"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        status: "-1"
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(CustomerAccountReportSchemaObject).options({ allowUnknown: true });

    const [contentRowNames, setContentRowNames] = useState(["customerCode", "firstName", "cardNumber", "registrationNumber", "mobileNo", "collectionPointName"]);

    const initialCsvHeaders = [
        { label: "Customer Code", value: "customerCode" },
        { label: "Customer Name", value: "firstName" },
        { label: "Card Number", value: "cardNumber" },
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Mobile No", value: "mobileNo" },
        { label: "Collection Point", value: "collectionPointName" },
        { label: "Status", value: "isActive" },

    ]
    const [csvHeaders, setCsvHeaders] = useState(initialCsvHeaders);
    const [csvData, setCsvData] = useState([]);
    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionVariance.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionVariance.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            factoryID: target.value,
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, CustomerAccountReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    function handleChange(e) {
        const target = e.target
        const value = target.name === 'isActive' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, CustomerAccountReportSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCUSTOMERACCOUNTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionVariance.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionVariance.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(false);

        const errorMessages = validate(schema, leafCollectionVariance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        getSelectedDropdownValuesForReport(leafCollectionVariance);
        var res = await services.getCustomerAccountData(leafCollectionVariance);
        if (res != null || res.length != 0) {

            res.forEach(x => {
                x.isActive = x.isActive == true ? "Active" : "InActive"
            });

            setReportData(res);
            setCsvData(res);
        }


    }

    function createFile() {
        var settings = {
            sheetName: ("Customer Account Report"),
            fileName: ("Customer Account Report"),
            writeOptions: {}
        }

        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: "0",
            date: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            status: searchForm.routeID,
            date: searchForm.date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Customer Account Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">

                                    <div className="col-md pb-1">

                                        <InputLabel shrink id="groupID">Group *</InputLabel>

                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={leafCollectionVariance.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group Name--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>

                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select fullWidth
                                            id="factoryID"
                                            name="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={leafCollectionVariance.factoryID}
                                            onChange={(e) => handleFactoryChange(e.target)}>
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionVariance.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Status</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="statusID"
                                            id="statusID"
                                            name="statusID"
                                            value={leafCollectionVariance.statusID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="-1">--Select Status--</MenuItem>
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="0">InActive</MenuItem>

                                        </Select>
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionVariance)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <br />
                                    <br />
                                    <br />
                                    <LoadingMaterialTable
                                        title=""
                                        columns={[
                                            { title: "Customer Code", field: "customerCode" },
                                            { title: "Customer Name", field: "firstName" },
                                            { title: "Card Number", field: "cardNumber" },
                                            { title: "Registration Number", field: "registrationNumber" },
                                            { title: "Collection Point", field: "collectionPointName" },
                                            { title: "Mobile No", field: "mobileNo" },
                                            { title: "Status", field: "isActive" }
                                        ]}
                                        data={reportData}
                                    />

                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Customer Leaf Collection Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />

                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
